export const COUNTRY_OPTIONS = [
  { id: 'SE', name: 'Sweden' },
  { id: 'DK', name: 'Denmark' },
  { id: 'GB', name: 'United Kingdom' },
  { id: 'DE', name: 'Germany' },
  { id: 'FI', name: 'Finland' },
  { id: 'NO', name: 'Norway' },
  { id: 'AT', name: 'Austria' },
  { id: 'CH', name: 'Switzerland' },
  { id: 'BE', name: 'Belgium' },
  { id: 'NL', name: 'The Netherlands' },
  { id: 'IE', name: 'Ireland' },
  { id: 'FR', name: 'France' },
  { id: 'ES', name: 'Spain' },
  { id: 'IT', name: 'Italy' },
  { id: 'LT', name: 'Lithuania' },
  { id: 'US', name: 'United States of America' },
  { id: 'CA', name: 'Canada' },
]

export const MERCHANT_ACCOUNT_TYPE_OPTIONS = [
  { id: 'pos', name: 'POS' },
  { id: 'ecom', name: 'ECOM' },
]

export const COUNTRIES_WITH_PROVINCE = ['AU', 'BR', 'CA', 'IN', 'MX', 'NZ', 'US']

export const US_STATES: Record<string, string> = {
  alabama: 'AL',
  alaska: 'AK',
  arizona: 'AZ',
  arkansas: 'AR',
  california: 'CA',
  colorado: 'CO',
  connecticut: 'CT',
  delaware: 'DE',
  florida: 'FL',
  georgia: 'GA',
  hawaii: 'HI',
  idaho: 'ID',
  illinois: 'IL',
  indiana: 'IN',
  iowa: 'IA',
  kansas: 'KS',
  kentucky: 'KY',
  louisiana: 'LA',
  maine: 'ME',
  maryland: 'MD',
  massachusetts: 'MA',
  michigan: 'MI',
  minnesota: 'MN',
  mississippi: 'MS',
  missouri: 'MO',
  montana: 'MT',
  nebraska: 'NE',
  nevada: 'NV',
  'new hampshire': 'NH',
  'new jersey': 'NJ',
  'new mexico': 'NM',
  'new york': 'NY',
  'north carolina': 'NC',
  'north dakota': 'ND',
  ohio: 'OH',
  oklahoma: 'OK',
  oregon: 'OR',
  pennsylvania: 'PA',
  'rhode island': 'RI',
  'south carolina': 'SC',
  'south dakota': 'SD',
  tennessee: 'TN',
  texas: 'TX',
  utah: 'UT',
  vermont: 'VT',
  virginia: 'VA',
  washington: 'WA',
  'west virginia': 'WV',
  wisconsin: 'WI',
  wyoming: 'WY',
  'district of columbia': 'DC',
}

export const CANADIAN_PROVINCES: Record<string, string> = {
  alberta: 'AB',
  'british columbia': 'BC',
  manitoba: 'MB',
  'new brunswick': 'NB',
  'newfoundland and labrador': 'NL',
  'northwest territories': 'NT',
  'nova scotia': 'NS',
  nunavut: 'NU',
  ontario: 'ON',
  'prince edward island': 'PE',
  quebec: 'QC',
  saskatchewan: 'SK',
  yukon: 'YT',
}
